import { gql } from "graphql-request";
import { Image, ImageFragment } from "./image";
import { Sys, SysFragment } from "./sys";

import { z } from "zod";

export const CommunityCreator = z.object({
  sys: Sys,
  communityCreatorName: z.string().nullable(),
  communityCreatorId: z.string().nullable(),
  communityCreatorSubmissionInfo: z.string().nullable(),
  communityCreatorThumbnail: Image.nullable(),
  communityCreatorThumbnailEn: Image.nullable(),
});

export type CommunityCreator = z.infer<typeof CommunityCreator>;

export const CommunityCreatorFragment = gql`
  fragment CommunityCreatorFragment on CommunityCreator {
    sys {
      ...SysFragment
    }

    communityCreatorName
    communityCreatorId
    communityCreatorSubmissionInfo
    communityCreatorThumbnail {
      ...ImageFragment
    }

    communityCreatorThumbnailEn: communityCreatorThumbnail(locale: "en") {
      ...ImageFragment
    }
  }

  ${ImageFragment}
  ${SysFragment}
`;
